import { Component } from '@theme/component';

/**
 * Gorgias Help Center embed host.
 *
 * The FAQ content renders inside a Gorgias iframe injected by the patched
 * vendor loader (_vendor--gorgias-help-center.js). This component adds an
 * anti-scroll-jack guard: if the page scrolls more than 100px without recent
 * user input (wheel/touch/keyboard), it snaps back — the iframe's height
 * adjustments must never move the page under the visitor.
 *
 * @extends {Component<{}>}
 */
class HelpGorgiasFaq extends Component {
	/** @type {AbortController|null} */
	#abortController = null;

	/** @type {number} */
	#lastY = 0;

	/** @type {boolean} */
	#userScrolling = false;

	/** @type {number} */
	#userScrollTimer = 0;

	connectedCallback() {
		super.connectedCallback();

		this.#abortController = new AbortController();
		const { signal } = this.#abortController;
		this.#lastY = window.scrollY;

		for (const eventName of ['wheel', 'touchstart', 'keydown']) {
			window.addEventListener(
				eventName,
				() => {
					this.#userScrolling = true;
					clearTimeout(this.#userScrollTimer);
					this.#userScrollTimer = setTimeout(() => {
						this.#userScrolling = false;
					}, 200);
				},
				{ passive: true, signal },
			);
		}

		window.addEventListener(
			'scroll',
			() => {
				const currentY = window.scrollY;
				if (!this.#userScrolling && Math.abs(currentY - this.#lastY) > 100) {
					window.scrollTo(0, this.#lastY);
					return;
				}
				this.#lastY = currentY;
			},
			{ signal },
		);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		this.#abortController?.abort();
		this.#abortController = null;
		clearTimeout(this.#userScrollTimer);
	}
}

if (!customElements.get('help-gorgias-faq')) {
	customElements.define('help-gorgias-faq', HelpGorgiasFaq);
}
